import update from 'immutability-helper';
import constants from 'constants';

const {
  ADD_WEBINARS,
  ADD_USERS_WEBINARS,
  UPCOMING_WEBINARS,
  CURRENT_WEBINARS,
  PREVIOUS_WEBINARS,
  LIVE_WEBINARS,
  UPDATE_WEBINAR,
  SET_TEMP_WEBINAR,
  CLEAN_WEBINARS,
  CLEAN_USERS_WEBINARS,
  ADD_ADMIN_WEBINARS,
  ADD_ADMIN_DASHBOARD_WEBINARS,
  SET_WEBINARS,
  RECORDED_WEBINARS
} = constants;

const webinars = (webinars = {
    [UPCOMING_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0
    },
    [CURRENT_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0
    },
    [PREVIOUS_WEBINARS]: {
      values: [],
      page: 0,
      pages: 0,
      count: 0
    },
    usersWebinars: {
      [RECORDED_WEBINARS]: {
        page: 0,
        pages: 0,
        values: [],
        cpds: 0
      },
      [LIVE_WEBINARS]: {
        page: 0,
        pages: 0,
        values: [],
        cpds: 0
      },
    },
    adminWebinars: {
      values: [],
      page: 1,
      total_pages: 0,
      query: {
        title: '',
        date_from: null,
        date_to: null,
        order: {
          created_at: 'desc'
        }
      }
    },
    dashboardWebinars: {
      values: [],
      page: 1,
      total_pages: 0
    },
    tmp: {}
  }, {
    type,
    webinarType,
    payload,
    page,
    pages,
    count
  }) => {
  switch(type) {
    case ADD_WEBINARS:
      return { ...webinars,
        ...{
          [webinarType]: {
            values: update(webinars[webinarType].values, {
              $push: payload
            }),
            page,
            pages,
            count
          }
        }
      }
    case SET_WEBINARS:
      return { ...webinars,
        ...{
          [webinarType]: {
            ...webinars[webinarType],
            values: payload
          }
        }
      }
    case ADD_USERS_WEBINARS:
      return { ...webinars,
        ...{
          usersWebinars: {
            ...webinars.usersWebinars,
            [webinarType]: {
              values: update(webinars.usersWebinars[webinarType].values, {
                $push: payload.webinars
              }),
              page,
              cpds: payload.cpds,
              pages
            }
          }
        }
      }
    case UPDATE_WEBINAR:
      const webinarForUpdateId = payload.webinar.id;
      const replaceWith = (webinar) => (
        webinar.id == webinarForUpdateId ? payload.webinar : webinar
      )
      const tempWebinar = webinarForUpdateId == webinars.tmp.id ? payload.webinar : webinars.tmp;
      return {
        ...webinars,
        ...{
          [UPCOMING_WEBINARS]: {
            ...webinars[UPCOMING_WEBINARS],
            values: webinars[UPCOMING_WEBINARS].values.map(replaceWith)
          },
          [CURRENT_WEBINARS]: {
            ...webinars[CURRENT_WEBINARS],
            values: webinars[CURRENT_WEBINARS].values.map(replaceWith)
          },
          [PREVIOUS_WEBINARS]: {
            ...webinars[PREVIOUS_WEBINARS],
            values: webinars[PREVIOUS_WEBINARS].values.map(replaceWith)
          },
          usersWebinars: {
            ...webinars.usersWebinars,
            [PREVIOUS_WEBINARS]: {
              ...webinars.usersWebinars[RECORDED_WEBINARS],
              values: webinars.usersWebinars[RECORDED_WEBINARS].values.map(replaceWith)
            },
            [LIVE_WEBINARS]: {
              ...webinars.usersWebinars[LIVE_WEBINARS],
              values: webinars.usersWebinars[LIVE_WEBINARS].values.map(replaceWith)
            },
          },
          tmp: tempWebinar
        }
      }
    case SET_TEMP_WEBINAR:
      return {
        ...webinars,
        tmp: payload.webinar
      }
    case CLEAN_WEBINARS:
      return {
        ...webinars,
        [UPCOMING_WEBINARS]: {
          values: [],
          page: 0,
          count: 0
        },
        [CURRENT_WEBINARS]: {
          values: [],
          page: 0,
          count: 0
        },
        [PREVIOUS_WEBINARS]: {
          values: [],
          page: 0,
          count: 0
        },
      }
    case CLEAN_USERS_WEBINARS:
      return {
        ...webinars,
        usersWebinars: {
          [RECORDED_WEBINARS]: {
            page: 0,
            values: []
          },
          [LIVE_WEBINARS]: {
            page: 0,
            values: []
          },
        }
      }
    case ADD_ADMIN_WEBINARS:
      return {
        ...webinars,
        adminWebinars: {
          values: payload.values || [],
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          query: payload.query
        }
      }
      break;
    case ADD_ADMIN_DASHBOARD_WEBINARS:
      return {
        ...webinars,
        dashboardWebinars: {
          values: payload.values || [],
          count: payload.count,
          page: payload.page,
          total_pages: payload.total_pages,
          total_users: payload.total_users
        }
      }
      break;
    default: return webinars
  }
}

export { webinars };



/** WEBPACK FOOTER **
 ** ./src/reducers/webinars.js
 **/